/**
 * Shown while the first `me` request is in flight.
 *
 * Deliberately plain: it is on screen for a few hundred milliseconds. Its job
 * is to stop the screen from committing to an answer it does not have yet —
 * treating "not known" as "not signed in" flashes the login form at people who
 * are signed in.
 */
export function AuthPending() {
  return (
    <div
      className="grid min-h-screen place-items-center font-mono text-xs"
      style={{ color: 'var(--muted)' }}
    >
      <span>Checking your session…</span>
    </div>
  );
}
